import request from '../utils/request';

// 登录
export const login = (data) => {
  return request({
    url: '/login',
    method: 'post',
    data,
  });
};

// 注册
export const register = (data) => {
  return request({
    url: '/register',
    method: 'post',
    data,
  });
};

// 发送验证码
export const sendVerificationCode = (email) => {
  return request({
    url: '/send-code',
    method: 'post',
    data: { email },
  });
};

// 更新用户信息
export const updateUser = (id, data) => {
  return request({
    url: `/user/${id}`,
    method: 'put',
    data,
  });
};
